import React from "react";
import { Box, Tab, Tabs, useTheme,useMediaQuery, } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as Constant from "../../features/constant";
import '../referral/style.css';


const InfoTabs = ({ sections, selectedTab, handleTabChange }) => {
  const theme = useTheme();
  const desktopView = useMediaQuery(theme.breakpoints.up("md"));
  const { t } = useTranslation();

  const sidebarBgColor =process.env.REACT_APP_TOOLBAR_COLOR;
  const navigate = useNavigate();
  const isLightTheme = process.env.REACT_APP_IS_LIGHT_THEME;

  return (
    desktopView ? (
    <Box className='sidebar' sx={{"--sidebar-bg": process.env.REACT_APP_COLOR_PROFILE_BACKGROUND || theme.palette.background.paper, mt:5}}>
      <div className='menuWrapper'>
        <Box sx={{
          backgroundColor: sidebarBgColor, 
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: "7px",
          fontSize: "medium",
          fontWeight: "bold",
          color: "white",
        }}>
          {/* Invite Friends */}
        </Box>
        {sections.map((section, index) => (
        <div
          key={section.id}
          className="menuItem"
          onClick={() => handleTabChange(null, index)}
         style={{
          color: selectedTab === index ? theme.palette.primary.main : (isLightTheme ? "black" : "white"),
          backgroundColor: selectedTab === index ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
          borderLeft: selectedTab === index ? `4px solid ${theme.palette.primary.main}` : '4px solid transparent',
          padding: '10px 16px',
          margin: '4px 0',
          cursor: 'pointer',
          fontWeight: 500,
          textAlign: 'left',
          whiteSpace: 'nowrap',
          transition: 'all 0.3s ease',
          borderRadius: 0,
        }}
        >
          {section.label}
        </div>
      ))}
      </div>
    </Box>
  ) : (
<Box sx={{marginTop: '20px'}}>
    <Box
      sx={{
        bgcolor: "background.secondarypaper",
        top: 0,
        zIndex: 10,
        pt: "64px",
      }}
    >
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="Page Sections"
        textColor="primary"
        indicatorColor="primary"
        sx={{
          "& .MuiTabs-indicator": { display: "none" },
        }}
      >
        {sections.map((section) => (
          <Tab
            key={section.id}
            label={section.label}
            sx={{
              color: isLightTheme? "black": "white",
              backgroundColor: process.env.REACT_APP_COLOR_PROFILE_BACKGROUND || theme.palette.background.paper,
              border: `2px solid ${isLightTheme ? "black" : "white"}`,
              borderRadius: "20px",
              mx: 1,
              px: 2,
              py: 1,
              textTransform: "none",
              whiteSpace: "nowrap",
              fontWeight: 600,
              "&.Mui-selected": {
                  ...(isLightTheme && {
                    backgroundColor: theme.palette.primary.main,
                    color: "black",
                    borderColor: theme.palette.primary.main, 
                  }),
                  ...(!isLightTheme && {
                    backgroundColor: 'white',
                    color: theme.palette.primary.main,
                    borderColor: 'white', 
                  }),
                },
              "&:hover": {
                bgcolor: "rgba(255,255,255,0.2)",
              },
            }}
          />
        ))}
      </Tabs>
    </Box>
    </Box>
  )   
  );
};

export default InfoTabs;
